import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { AUCTION_SEALED_FLOW_API_BASE_URL } from '../api-base-url.token';
import { PlaceSealedBidRequestDto } from '../schemas/place-sealed-bid-request.dto';
import { SealedBidResponseDto } from '../schemas/sealed-bid-response.dto';
import { CurrentOrganizationSealedBidResponseDto } from '../schemas/current-organization-sealed-bid-response.dto';

@Injectable({ providedIn: 'root' })
export class BidAuctionSealedFlow {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUCTION_SEALED_FLOW_API_BASE_URL)}/BidAuctionSealedFlow`;

    placeBid(payload: PlaceSealedBidRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/PlaceBid`)
            .put(payload)
            .json<SealedBidResponseDto>()
            .build()
            .send();
    }

    deleteBid(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/DeleteBid`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', String(id)))
            .build()
            .send();
    }

    getCurrentBidbyAuctionId(auctionId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetCurrentBidbyAuctionId`)
            .get()
            .json<CurrentOrganizationSealedBidResponseDto>()
            .withHttpParams(new HttpParams().set('auctionId', String(auctionId)))
            .build()
            .send();
    }

    getCurrentBids(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetCurrentBids`)
            .get()
            .json<CurrentOrganizationSealedBidResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', String(tradingProcedureId)))
            .build()
            .send();
    }
}
